import { isSafari, isIOS } from 'utils';

const WEB_CHANGES = () => {
  // iOS hover fix
  if (!isIOS()) {
    const PROPER_HOVER_CLASS = 'proper-hover';
    document.body.classList.add(PROPER_HOVER_CLASS);
  }

  if (isIOS() && isSafari()) {
    // disable zoom on iOS
    document.addEventListener('gestureend', (e: any) => {
      if (e.scale && e.scale !== 1) {
        e.preventDefault();
      }
    }, false);

    document.addEventListener('touchmove', (e: any) => {
      if (e.scale && e.scale !== 1) {
        e.preventDefault();
      }
    }, false);

    let lastTouchEnd = 0;
    document.addEventListener('touchend', (e: TouchEvent) => {
      const now = Date.now();
      if (now - lastTouchEnd <= 300) {
        e.preventDefault();
      }

      lastTouchEnd = now;
    }, false);
  }
};

const CHANGES = [
  WEB_CHANGES,
];

class PlatformManager {
  public init() {
    this.applyChanges();
    this.disableContextMenu();
    this.addCommitHelpers();
  }

  private applyChanges() {
    CHANGES.forEach((changes) => changes());
  }

  private disableContextMenu() {
    if (__DEV__) return;

    document.oncontextmenu = () => false;
  }

  private addCommitHelpers() {
    window.__COMMIT_HASH = () => __COMMIT_SHORT__;
  }
}

export default new PlatformManager();
